import { Badge, Button, Divider, Flex, HStack, Text } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";
import { DonationTransaction } from "../apis";
import dayjs from "dayjs";
import { useAppUtil } from "../hooks";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { APPC } from "../config";

interface AppStatasticListCardProps {
    title?: string;
    data: DonationTransaction[];
    onClick?: () => void;
}

export const AppStatasticListCard = ({
    title,
    data,
    onClick,
}: AppStatasticListCardProps) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const { statusVariant } = useAppUtil();
    return (
        <Flex
            direction={"column"}
            p={"1.25rem"}
            gap={"1.5rem"}
            border={"1px solid var(--chakra-colors-greyT90)"}
            borderRadius={"4px"}
            bg={"var(--chakra-colors-white)"}
            justifyContent={"space-between"}
        >
            {title && (
                <Text textStyle={"mediumXl"} whiteSpace={"nowrap"}>
                    {title}
                </Text>
            )}
            {data &&
                data?.map((item, index) => (
                    <Flex key={index} direction={"column"} gap={"0.5rem"}>
                        <Divider mb={3} />
                        <HStack justifyContent={"space-between"}>
                            <Text textStyle={"semiBoldSm"}>
                                {`DT-${dayjs(item?.createdAt)
                                    .tz(APPC.TIMEZONE)
                                    .format("YYYYMMDD")}-${item?.id}`}
                            </Text>
                            <Text
                                textStyle={"regularSm"}
                                color={"var(--chakra-colors-contentT40)"}
                            >
                                {dayjs(`${item?.createdAt}`)
                                    .tz(APPC.TIMEZONE)
                                    .format("HH:mm - MMM DD")}
                            </Text>
                        </HStack>
                        <HStack justifyContent={"space-between"}>
                            <Text textStyle={"semiBoldXl"}>
                                &euro; {item?.amount / 100}
                            </Text>
                            <Badge variant={statusVariant(item?.status)}>
                                {item?.status}
                            </Badge>
                        </HStack>
                        <Text
                            textStyle={"regularSm"}
                            color={"var(--chakra-colors-contentT40)"}
                        >
                            {item?.customer?.email}
                        </Text>
                    </Flex>
                ))}
            {onClick && (
                <Button variant={"outline"} onClick={onClick}>
                    <AppIcon name="icl-chevron-right-alt" w="1rem" />
                </Button>
            )}
        </Flex>
    );
};
